import admConfig from "./codeSystemConfigs/admConfig";
import icd10Config from "./codeSystemConfigs/icd10Config";
import icpc2Config from "./codeSystemConfigs/icpc2Config";
import nkpkConfig from "./codeSystemConfigs/nkpkConfig";
import norpatConfig from "./codeSystemConfigs/norpatConfig";
import phbuConfig from "./codeSystemConfigs/phbuConfig";
import { CodeSystem, EsConfigMap } from "./types";

const defaultConfig: EsConfigMap = {
  [CodeSystem.Adm]: admConfig,
  [CodeSystem.Icd10]: icd10Config,
  [CodeSystem.Icpc2]: icpc2Config,
  [CodeSystem.Norpat]: norpatConfig,
  [CodeSystem.Nkpk]: nkpkConfig,
  [CodeSystem.Phbu]: phbuConfig
};

export default defaultConfig;
